import HTTPResponse from '../utils/http/interfaces/HttpResponse';
import http from '../utils/http';
import httpVerbs from '../utils/http/httpVerbs';
import config, { getApiUrl } from '../utils/config';
import { FirmLogoAndNameResponseType } from '@app/types/ResponseTypes';
import { FeaturesConfig } from '@app/redux/types/ConfigState';
import { ServiceType } from '@app/types/ServiceType';

export const getCountries = (): Promise<HTTPResponse<any>> => {
  return http({
    method: httpVerbs.GET,
    url: getApiUrl(config.api.organizationAPI.countries),
  });
};

export const getFirmNameAndLogo = (): Promise<HTTPResponse<FirmLogoAndNameResponseType>> => {
  return http({
    method: httpVerbs.GET,
    url: getApiUrl(config.api[ServiceType.Dashboard].firmLogoAndName),
  });
};

export const getFeatures = async (): Promise<FeaturesConfig> => {
  try {
    const response = await http({
      method: httpVerbs.GET,
      url: getApiUrl(config.api[ServiceType.DocumentAdministration].getFeatures),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getVirusScanStatus = async (): Promise<boolean> => {
  try {
    const response = await http({
      method: httpVerbs.GET,
      url: getApiUrl(config.api[ServiceType.DocumentAdministration].getVirusScanStatus),
    });
    return response.data?.enabled === true;
  } catch (error) {
    throw error.response?.data || error;
  }
};